import React from "react";
import '../index.css';

function Tools(){
    return(
        <>
        <div className="heroic">
            <h1>PREMIUM <span>TOOLS</span></h1><br />
        </div>
        </>
    );
}

export default Tools;